<div class="variant-header-container {{ formVariant.pristine ? 'variant-saved' : 'variant-dirty' }}" *ngIf="variant && formVariant">
  <span class="left-part">
    <!-- status drop-down -->
    <mat-form-field appearance="fill" [formGroup]="formVariant" class="space-h-l">
      <mat-label>{{ 'STATUT' | translate }}</mat-label>
      <mat-select formControlName="status" id="RecipesModifyVariantStatusBtn" (selectionChange)="statusChange()">
        <ng-container *ngFor="let status of statusesOptions">
          <!-- ngIf : do not display the 'DELETED' status unless the variant already has this status. The deletions are to be handled with a dedicated button -->
          <!-- ngIf : do not display the 'WAITING_FOR_TRANSLATION' status unless the variant already has this status. This status must must be handled with specific screen and action -->
          <mat-option
            [value]="status.key"
            [disabled]="variant.packs && variant.packs.length > 0 && (status.key === 'DELETED' || status.key === 'WAITING_FOR_TRANSLATION')"
            *ngIf="
              (status.key !== 'DELETED' || variant.status === 'DELETED') &&
              (status.key !== 'WAITING_FOR_TRANSLATION' || variant.status === 'WAITING_FOR_TRANSLATION')
            "
            >{{ status.label }}</mat-option
          >
        </ng-container>
      </mat-select>
    </mat-form-field>

    <!-- text displaying the last modification and triggering the informative menu -->
    <span [matMenuTriggerFor]="history" class="history-menu-trigger space-h-l">
      <span class="space-h-m" id="RecipesModifyVariantModifDateLbl">
        {{ 'MODIFIED_ON' | translate }} {{ variant.modificationDate | date : 'dd/MM/yyyy HH:mm' }}
        <ng-container *ngIf="variant.modifier">
          <br />
          {{ 'BY' | translate }} {{ variant.modifier }}
        </ng-container>
      </span>
      <div class="mat-select-arrow-wrapper"><div class="mat-select-arrow"></div></div>
    </span>

    <!-- informative menu containing the variant history -->
    <mat-menu #history="matMenu">
      <span mat-menu-item disabled *ngIf="variant.modificationDate || variant.modifier">
        <ng-container *ngIf="variant.modificationDate">
          {{ 'MODIFIED_ON' | translate }} {{ variant.modificationDate | date : 'dd/MM/yyyy HH:mm' }}
        </ng-container>
        -
        <ng-container *ngIf="variant.modifier"> {{ 'BY' | translate }} {{ variant.modifier }} </ng-container>
      </span>
      <mat-divider></mat-divider>
      <span mat-menu-item disabled *ngIf="variant.publicationDate || variant.publicator">
        <ng-container *ngIf="variant.publicationDate">
          {{ 'PUBLISHED_ON' | translate }} {{ variant.publicationDate | date : 'dd/MM/yyyy HH:mm' }}
        </ng-container>
        -
        <ng-container *ngIf="variant.publicator"> {{ 'BY' | translate }} {{ variant.publicator }} </ng-container>
      </span>
      <mat-divider></mat-divider>
      <span mat-menu-item disabled *ngIf="variant.creationDate || variant.creator">
        <ng-container *ngIf="variant.creationDate">
          {{ 'CREATED_ON' | translate }} {{ variant.creationDate | date : 'dd/MM/yyyy HH:mm' }}
        </ng-container>
        -
        <ng-container *ngIf="variant.creator"> {{ 'BY' | translate }} {{ variant.creator }} </ng-container>
      </span>
    </mat-menu>

    <!-- Modification status informations -->
    <span *ngIf="formVariant.pristine" class="status-info-saved">
      <span class="space-h-s">{{ 'SAVED' | translate }}</span>
      <i class="fas fa-check-circle" aria-hidden="true"></i>
    </span>
    <span *ngIf="formVariant.dirty" class="status-info-dirty">
      <span class="space-h-s">{{ 'DIRTY' | translate }}</span>
      <i class="fas fa-times-circle" aria-hidden="true"></i>
    </span>
  </span>

  <!-- right part of the header -->
  <span class="right-part">
    <div class="space-h-xl action-list">
      <button class="btn btn-transparent space-l-m" [disabled]="formVariant.dirty" (click)="delete()">
        <i class="fas fa-trash" aria-hidden="true" [matTooltip]="'VARIANTS.DELETE_VARIANT' | translate" matTooltipClass="tooltip-main"></i>
      </button>
      <button
        id="RecipesModifyVariantHistoryBtn"
        class="btn btn-transparent space-l-s"
        (click)="openHistoryPopin()"
        matTooltip="{{ 'AUDIT.MODAL.TITLE' | translate }}"
        matTooltipClass="tooltip-main"
      >
        <i class="fas fa-history" aria-hidden="true"></i>
      </button>
      <a
        id="RecipesModifyVariantViewLnk"
        class="link-btn btn btn-transparent space-l-m"
        [href]="'#/recipes/view/' + variant.identifier.sourceSystem + '/' + variant.identifier.functionalId + '?redirectNewBo=true'"
        matTooltip="{{ 'BTN_PREVIEW' | translate }}"
        matTooltipClass="tooltip-main"
      >
        <i class="fas fa-eye" aria-hidden="true"></i>
      </a>
      <button
        id="RecipesModifyVariantDeepLinkBtn"
        class="btn btn-transparent space-l-s"
        [disabled]="variant.status !== 'PUBLISHED'"
        [matMenuTriggerFor]="deepLink"
      >
        <i class="fas fa-link" aria-hidden="true" matTooltip="{{ 'DEEPLINK.MANAGE' | translate }}" matTooltipClass="tooltip-main"></i>
      </button>
      <mat-menu #deepLink="matMenu" xPosition="before">
        <ng-template matMenuContent>
          <app-deep-link
            [deepLinkData]="{
              functionalId: variant.identifier.functionalId,
              resource: 'recipes',
              domain: variant.domain,
              lang: variant.lang,
              market: variant.market,
              type: ''
            }"
          ></app-deep-link>
        </ng-template>
      </mat-menu>
    </div>
    <div class="buttons-container">
      <button
        mat-button
        class="btn btn-warn space-v-s"
        id="RecipesModifyVariantResetBtn"
        (click)="resetForm.emit()"
        [disabled]="formVariant.pristine"
      >
        {{ 'VARIANTS.RESET_VARIANT' | translate }}
      </button>
      <button
        mat-button
        class="btn btn-submit"
        id="RecipesModifyVariantSaveBtn"
        (click)="saveVariant.emit()"
        [disabled]="formVariant.pristine || formVariant.invalid"
      >
        {{ 'VARIANTS.SAVE_VARIANT' | translate }}
      </button>
    </div>
  </span>
</div>
